<strong *ngIf=" firebaseService.myCalls &&  firebaseService.myCalls.length > 0">Meine Anrufe</strong>
<mat-card appearance="outlined" *ngFor="let call of firebaseService.myCalls" style="margin-bottom: 8px; position: relative; padding: 12px;">
    <div style="position: absolute; top: 8px; right: 8px;">
        <mat-icon *ngIf="!call.clientId && !call.leadId">help</mat-icon>
        <mat-icon *ngIf="!call.clientId && call.leadId">account_box</mat-icon>
        <mat-icon *ngIf="call.clientId">group</mat-icon>
    </div>
    <div
        style="position: absolute; top: 8px; left: 8px; display: flex; justify-content: center; flex-direction: column; align-items: center;">
        <div>
            <mat-icon *ngIf="!call.hasEnded">phone</mat-icon>
            <mat-icon *ngIf="call.hasEnded" [class.red]="!call.isAnswered" style="cursor: pointer;"
                (click)="startCall(call.clientNumber)">call_end</mat-icon>
        </div>
        <span style="margin: 4px 0; font-size: 11px; color: #666;">{{glo.getDauer(call)}}</span>
        <div>
            <mat-icon [class.green]="call.ticketId" style="cursor: pointer;" (click)="createTicket(call)">checklist_rtl
            </mat-icon>
        </div>
    </div>
    <div style="position: absolute; bottom: 8px; right: 8px;">
        <mat-icon *ngIf="call.hasEnded || schonAlt(call.startAtUnix)" style="cursor: pointer;"
            (click)="setCallArchiv(call)">archive</mat-icon>
    </div>
    <div style="margin-left: 55px;">

        <mat-card-title *ngIf="!call.clientId && !call.leadId" style="font-size: 12px;"> {{call.clientNumber}}
        </mat-card-title>
        <mat-card-title *ngIf="call.clientId">
            <app-firmenname [fontSize]="'12'" [clientId]="call.clientId"></app-firmenname>
        </mat-card-title>
        <mat-card-title *ngIf="!call.clientId && call.leadId">
            <app-firmenname [fontSize]="'12'" [clientId]="call.leadId" [isLead]="true"></app-firmenname>
        </mat-card-title>
        <mat-card-subtitle>
            <span style="font-size: 12px;">{{call.startAtUnix | date: 'dd.MM.yyyy - HH:mm'}}</span>
        </mat-card-subtitle>
    </div>
    <mat-card-actions>

    </mat-card-actions>

</mat-card>

<strong *ngIf=" firebaseService.missedCalls &&  firebaseService.missedCalls.length > 0">Verpasste Anrufe</strong>
<mat-card appearance="outlined" *ngFor="let call of firebaseService.missedCalls" style="margin-bottom: 8px; position: relative; padding: 12px; border-left: 3px solid #f44336;">
    <div style="position: absolute; top: 8px; right: 8px;">
        <mat-icon *ngIf="!call.clientId && !call.leadId">help</mat-icon>
        <mat-icon *ngIf="!call.clientId && call.leadId">account_box</mat-icon>
        <mat-icon *ngIf="call.clientId">group</mat-icon>
    </div>
    <div style="position: absolute; bottom: 8px; right: 8px;">
        <mat-icon *ngIf="call.hasEnded || schonAlt(call.startAtUnix)" style="cursor: pointer;"
            (click)="setCallArchiv(call)">archive</mat-icon>
    </div>
    <div style="position: absolute; top: 8px; left: 8px; display: flex; flex-direction: column; align-items: center;">
        <div>
            <mat-icon *ngIf="!call.hasEnded">phone</mat-icon>
            <mat-icon *ngIf="call.hasEnded" style="cursor: pointer; color: #f44336;" (click)="startCall(call.clientNumber)">call_end</mat-icon>
        </div>
        <span style="margin-top: 4px; font-size: 11px; color: #666;">{{glo.getDauer(call)}}</span>

    </div>
    <div style="margin-left: 55px;">
        <mat-card-title *ngIf="!call.clientId && !call.leadId"> {{call.clientNumber}}</mat-card-title>
        <mat-card-title *ngIf="call.clientId">
            <app-firmenname [clientId]="call.clientId"></app-firmenname>
        </mat-card-title>
        <mat-card-title *ngIf="call.leadId">
            <app-firmenname [clientId]="call.leadId" [isLead]="true"></app-firmenname>
        </mat-card-title>
        <mat-card-subtitle>
            {{call.startAtUnix | date: 'dd.MM.yyyy - HH:mm'}}
        </mat-card-subtitle>
    </div>
    <mat-card-actions>

    </mat-card-actions>

</mat-card>
<div style="display: flex; flex-grow: 1;">

</div>
<ng-container *ngFor="let user of glo.sortedUsers()">
    <ng-container *ngIf="user.sipgateUserId && user.shortName !== 'JB' && !user.inaktiv">
        <mat-card appearance="outlined" style="margin-bottom: 4px; position: relative; padding: 6px; min-height: 56px;">
            <div style="position: absolute; top: 8px; right: 8px;">
                <mat-icon
                    *ngIf="userCalls[user.sipgateUserId] &&!userCalls[user.sipgateUserId].clientId && userCalls[user.sipgateUserId].leadId">
                    account_box</mat-icon>
                <!--
                <mat-icon *ngIf="userCalls[user.sipgateUserId] && userCalls[user.sipgateUserId].clientId">group
                </mat-icon>-->
            </div>
            <div style="position: absolute; bottom: 8px; right: 8px;">
                <app-admin-name-action-indicator [user]="user"></app-admin-name-action-indicator>
            </div>
            <div style="font-size: 10px; display: flex; flex-direction: row;">
                <div  style="margin-left: 3px; width: 63px; display: flex; align-items:center;  flex-direction: column;">
                    <div>
                        <mat-icon *ngIf="userCalls[user.sipgateUserId] && !userCalls[user.sipgateUserId].hasEnded">phone
                        </mat-icon>
                        <mat-icon *ngIf="userCalls[user.sipgateUserId] && userCalls[user.sipgateUserId].hasEnded"
                            style="cursor: pointer;" (click)="startCall(userCalls[user.sipgateUserId].clientNumber)">call_end</mat-icon>
                    </div>
                    <span *ngIf="userCalls[user.sipgateUserId]" style="font-size: 9px; color: #666; margin-top: 2px;">{{glo.getDauer(userCalls[user.sipgateUserId])}}</span>
                </div>
                <div style="margin-bottom: 10px;">
                    <div style="font-size: 10px; display: flex; flex-direction: column; margin-bottom: 15px; line-height: 12px;">
                        <span  *ngIf="!userCalls[user.sipgateUserId]">Kein Telefon</span>
                        <span  *ngIf="userCalls[user.sipgateUserId]">{{userCalls[user.sipgateUserId].startAtUnix | date: 'dd.MM.yyyy - HH:mm'}}</span>
                        <span
                            *ngIf="userCalls[user.sipgateUserId] && !userCalls[user.sipgateUserId].clientId && !userCalls[user.sipgateUserId].leadId">{{userCalls[user.sipgateUserId].clientNumber}}</span>
                            <app-firmenname *ngIf="userCalls[user.sipgateUserId] && userCalls[user.sipgateUserId].clientId" [fontSize]="'10'" [clientId]="userCalls[user.sipgateUserId].clientId">
                            </app-firmenname>
                            <app-firmenname *ngIf="userCalls[user.sipgateUserId] && userCalls[user.sipgateUserId].leadId" [fontSize]="'10'" [clientId]="userCalls[user.sipgateUserId].leadId"
                            [isLead]="true">
                        </app-firmenname>
                        
                    </div>

                    
                </div>
            </div>


        </mat-card>
    </ng-container>
</ng-container>